<template>
  <div id="room-app">
    <iframe
      :src="`${env.meta.VUE_APP_BASE_PRE_ROOM || ''}/room/index.html?${model}&t=1`"
      frameborder="0"
      width="100%"
      height="100%"
      id="xunw_zxdb"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "RoomApp",
  data() {
    return {
      model: "",
    };
  },
  created() {
    this.model = this.objectToUrlParams(this.$route.query);
  },
  methods: {
    objectToUrlParams(obj) {
      return Object.keys(obj)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
        )
        .join("&");
    },
  },
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#room-app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  * {
    box-sizing: border-box;
  }
}
</style>
